module.exports = __webpack_public_path__ + "img/fish.f89a02b2.svg";